import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from '@s20/components/common/Link';
import Chip from '../common/forms/Chip';
import { TipAlert } from '../common/TipAlert';
import { AppNavPaths } from '../Common';

export class Project {
    foremanId = null;
    requestedById = null;
    projectManagerId = null;
    projectName = '';
    subcontractorId = null;
    workOrderNumber = '';
    dispatchCompanyId = '';
    meetingLocation = null;
    jobLocation = null;
    notes = '';
    jobs = [];
    resources = [];
    jobTypeId = null;
    billingStartDate = new Date().toISOString().split('T')[0];
}

export const DuplicateWONote = ({ project, duplicateWOProjects }) => {
    if (!project.workOrderNumber) return null;
    return (
        <div className="mb-4">
            <TipAlert
                tipText="Note"
                label={(
                    <>
                        <strong>{project.workOrderNumber}</strong>
                        {' '}
                        has already been used in an existing project.
                        {!project.id ? (
                            <>
                                Are you sure you want to create a
                                <strong>new project</strong>
                                {' '}
                                with this Work Order #?
                            </>
                        ) : (
                            <> Are you sure you want to update this project with this Work Order #? </>
                        )}
                        <br />
                        <br />
                        If you would like to add a new job to an existing project, click on the project below:
                    </>
                )}
            />

            {duplicateWOProjects.map((dp) => (
                <Chip
                    key={dp.id}
                    component={Link}
                    to={`${AppNavPaths.Project}/${dp.id}`}
                    target="_blank"
                    className="mr-2"
                    rel="noopener noreferrer"
                    text={(
                        <>
                            {dp.projectNumber}
                            {' '}
                            <FontAwesomeIcon
                                icon={faArrowUpRightFromSquare}
                                className="ms-3"
                            />
                        </>
                      )}
                />
            ))}
        </div>
    );
};